import {
  OrderDirection,
  OrderLookup,
  SortOrder,
} from 'common/utils/commonTypes';
import { FilterArrayType } from 'common/components/Filters';
import { EntityDocumentsOrderBy } from 'common/types/globalTypes';
import { FileCabinetDocumentSearchVariables } from './__generated__/FileCabinetDocumentSearch';

const orderByMap = new Map<string, OrderLookup>([
  [
    'documentType',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_DESC',
      ],
    },
  ],
  [
    '_documentPoolName',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_POOL_NAME_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_POOL_NAME_DESC'],
    },
  ],
  [
    'indexName',
    {
      [OrderDirection.ASC]: ['INDEX_NAME_ASC'],
      [OrderDirection.DESC]: ['INDEX_NAME_DESC'],
    },
  ],
  [
    'indexReferenceNumber',
    {
      [OrderDirection.ASC]: ['INDEX_REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INDEX_REFERENCE_NUMBER_DESC'],
    },
  ],
  [
    'indexTransactionDate',
    {
      [OrderDirection.ASC]: ['INDEX_TRANSACTION_DATE_ASC'],
      [OrderDirection.DESC]: ['INDEX_TRANSACTION_DATE_DESC'],
    },
  ],
  [
    '_documentContents',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_CONTENTS_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_CONTENTS_DESC'],
    },
  ],
  [
    'comment',
    {
      [OrderDirection.ASC]: ['COMMENT_ASC'],
      [OrderDirection.DESC]: ['COMMENT_DESC'],
    },
  ],
  [
    'indexAmount',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],
  [
    'isoCode',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['FILE_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['FILE_REFERENCE_DESC'],
    },
  ],
  [
    '_exportDate',
    {
      [OrderDirection.ASC]: ['_SORT_EXPORT_DATE_ASC'],
      [OrderDirection.DESC]: ['_SORT_EXPORT_DATE_DESC'],
    },
  ],

  [
    '_createdDate',
    {
      [OrderDirection.ASC]: ['_CREATED_DATE_ASC'],
      [OrderDirection.DESC]: ['_CREATED_DATE_DESC'],
    },
  ],
  [
    '_exportedByUser',
    {
      [OrderDirection.ASC]: ['_EXPORTED_BY_USER_ASC'],
      [OrderDirection.DESC]: ['_EXPORTED_BY_USER_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: EntityDocumentsOrderBy[] = ['PRIMARY_KEY_ASC'];
  if (!sort) return orderByArray;
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};
export type FilterVariableType = Pick<
  FileCabinetDocumentSearchVariables,
  | 'filterCurrencyId'
  | 'filterDocumentTypeId'
  | 'filterFolderId'
  | 'filterProcessHistoryId'
  | 'isFilterUnprocessedDocuments'
  | 'filterBusinessUnitId'
  | 'filterDepartmentId'
>;

export const toFilterVariable = (filterList: FilterArrayType[]) => {
  const initialFilterList = {
    filterCurrencyId: undefined,
    filterDocumentTypeId: undefined,
    filterFolderId: undefined,
    filterProcessHistoryId: undefined,
    isFilterUnprocessedDocuments: undefined,
    filterBusinessUnitId: undefined,
    filterDepartmentId: undefined,
  };
  const filterVariablesList: Record<
    string,
    string | number | boolean | string[] | number[] | undefined
  > = filterList.reduce((accList, { filterKey, value }) => {
    accList[filterKey] = value;
    return accList;
  }, initialFilterList as Record<string, string | number | boolean | string[] | number[] | undefined>);
  return filterVariablesList;
};
